import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import WebResourceSecure from '../../modules/assurance/services/web-resource-secure.service';
import StalePreferencesDialog from '../../components/modal-dialog/stale-preferences-dialog/stale-preferences-dialog';
import moment from 'moment-timezone';
import DataProvider from './data-provider';
import DataRepository from './data-repository';
import DashboardService from '../../modules/assurance/services/dashboard.service';
import StackTrace from 'stacktrace-js';
import 'jstorage';

/*
 * Preferences Structure: { prop1: ..., prop2: ..., apps: [{prop1: ..., views: [{prop1: ..., panels:[{}], tabs:[{id:..., name:..., panels:[{},{}]}, {...}] },{...}]}, {...}, {...}]}
 */
var instance = null;

function PreferenceManager() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than once PreferenceManager.');
    }

    var self = this;
    self.deferredGetPreferences = {}; // holds pending get preferences calls to enable filtering of duplicate requests
    self.preferences = null;
    self.dataRepository = DataRepository.getInstance();
    self.defaultAAPrefs = null;
}

function idMatchPredicatBuilder(id) {
    return function(item) {
        return item ? String(id) === String(item.id) : false;
    };
}

function FindIndexById(list, id) {
    return _.findIndex(list, idMatchPredicatBuilder(id));
}

function FindById(list, id) {
    return _.find(list, idMatchPredicatBuilder(id));
}

function pruneDuplicateIds(list) {
    return _.uniqBy(list, 'id');
}

function RemoveById(list, id) {
    var index = _.findIndex(list, function(item) {
        return String(id) === String(item.id);
    });
    if (index < 0) {
        return false;
    }
    list.splice(index, 1);
    return true;
}

function RemoveNulls(list) {

    var found = false;

    if (!list) {
        return false;
    }

    for (var i = list.length - 1; i >= 0; i--) {

        if (!list[i]) {
            list.splice(i, 1);
            found = true;
        }
    }

    return found;
}

const DEFAULT_PREFERENCES = {

      version: 201709051728,
      apps: [
          {
              id: 'assurance',
              name: 'Service Assurance',
              views: [
                  {
                      id: 'dashboard',
                      name: 'Dashboard',
                      tabs: [
                          { id: 0, name: 'Home', type: 'flex', panels: []}
                      ]
                  },
                  {
                      id: 'capacity',
                      name: 'Capacity',
                      tabs: [
                          { id: 0, name: 'Home', type: 'flex', panels: []}
                      ]
                  }
              ]
          },
          {
              id: 'realtime',
              name: 'RealTime Monitoring',
              views: [
                  {
                      id: 'alerts',
                      name: 'Alerts',
                      tabs: [
                          {
                              id: 0,
                              name: 'Alerts',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'Alerts',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }
              ]
          },
          {
              id: 'webex',
              name: 'WebEx Historical',
              views: [
                  {
                      id: 'webexlogidashboard',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiWebexDashboard',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'webexlogiadoption',
                      name: 'Adoption',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiWebexAdoption',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'webexmeetings',
                      name: 'Meetings',
                      tabs: [
                          {
                              id: 0,
                              name: 'Meetings',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'WebexMeetingsFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'WebexMeetingsSummary',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  },
                                  {
                                      componentType: 'WebexMeetingsDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'webexusers',
                      name: 'Users',
                      tabs: [
                          {
                              id: 0,
                              name: 'Users',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'WebexUsersFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'WebexUsersSummary',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  },
                                  {
                                      componentType: 'WebexUsersDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'webexparticipants',
                      name: 'Participants',
                      tabs: [
                          {
                              id: 0,
                              name: 'Users',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'WebexParticipantsFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'WebexMeetingParticipants',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'webexschedules',
                      name: 'Reports',
                      tabs: [
                          {
                              id: 0,
                              name: 'Schedules',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'webexSchedules',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }
              ]
          },
          {
              id: 'lync',
              name: 'Lync Historical',
              views: [
                  {
                      id: 'lynclogidashboard',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiLyncDashboard',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'lyncusers',
                      name: 'Users',
                      tabs: [
                          {
                              id: 0,
                              name: 'Users',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LyncUsersFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'LyncUsersSummary',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  },
                                  {
                                      componentType: 'LyncUsersDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'lyncschedules',
                      name: 'Reports',
                      tabs: [
                          {
                              id: 0,
                              name: 'Schedules',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'lyncSchedules',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }
              ]
          },
          {
              id: 'historical',
              name: 'vAnalytics Historical',
              views: [
                  {
                      id: 'historicallogidashboard',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiHistoricalDashboard',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historicallogiadoption',
                      name: 'Adoption',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiHistoricalAdoption',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historicallogiissues',
                      name: 'Issues',
                      tabs: [
                          {
                              id: 0,
                              name: 'Overview',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiHistoricalIssues',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historicallogicapacity',
                      name: 'Capacity',
                      tabs: [
                          {
                              id: 0,
                              name: 'Search',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'LogiHistoricalCapacity',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historicalmeetings',
                      name: 'Meetings',
                      tabs: [
                          {
                              id: 0,
                              name: 'Meetings',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalMeetingsFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalMeetingsSummary',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  },
                                  {
                                      componentType: 'HistoricalMeetingsDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 1,
                              name: 'VMRs',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalMeetingVMRFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalMeetingVMRSummary',
                                      options: {},
                                      seq: 2
                                  },
                                  {
                                      componentType: 'HistoricalMeetingVMRDetails',
                                      options: {},
                                      seq: 3
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 2,
                              name: 'Participants',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalMeetingParticipantFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalMeetingParticipantSummary',
                                      options: {},
                                      seq: 2
                                  },
                                  {
                                      componentType: 'HistoricalMeetingParticipantDetails',
                                      options: {},
                                      seq: 3
                                  }
                              ],
                              panels: []
                          },
                      ]
                  },
                  {
                      id: 'historicalendpoints',
                      name: 'Endpoints',
                      tabs: [
                          {
                              id: 0,
                              name: 'Managed',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalManagedEndpointsFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalManagedEndpointsSummary',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  },
                                  {
                                      componentType: 'HistoricalManagedEndpointsDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 1,
                              name: 'Unmanaged',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalUnmanagedEndpointFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalUnmanagedEndpointSummary',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  },
                                  {
                                      componentType: 'HistoricalUnmanagedEndpointDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 2,
                              name: 'Inventory',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalEndpointInventoryFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalEndpointInventoryDetails',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 3
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 3,
                              name: 'Call Details',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalIssuesFlexQuery',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalIssuesDetails',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          },
                      ]
                  },
                  {
                      id: 'historicalschedules',
                      name: 'Reports',
                      tabs: [
                          {
                              id: 0,
                              name: 'Schedules',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'historicalSchedules',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }
              ]
          },
          {
              id: 'historical2',
              name: 'vAnalytics Historical2',
              views: [
                  {
                      id: 'historical2dashboard',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'flex',
                              fixedpanels: [],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historical2adoption',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'flex',
                              fixedpanels: [],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historical2issues',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'flex',
                              fixedpanels: [],
                              panels: []
                          }
                      ]
                  }, {
                      id: 'historical2capacity',
                      name: 'Dashboard',
                      tabs: [
                          {
                              id: 0,
                              name: 'Dashboard',
                              type: 'flex',
                              fixedpanels: [],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historical2capacitydetails',
                      name: 'Capacity Details',
                      tabs: [
                          {
                              id: 0,
                              name: 'Details',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalCapacityDetailsParticipantsXml',
                                      options: {}, //  { id: 'logialerts1' }
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historical2meetings',
                      name: 'Meetings',
                      tabs: [
                          {
                              id: 0,
                              name: 'Meetings',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalMeetingMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalMeetingXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 1,
                              name: 'VMRs',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalMeetingVmrMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalMeetingVmrXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 2,
                              name: 'Participants',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalMeetingParticipantMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalMeetingParticipantXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historical2infrastructure',
                      name: 'Infrastructure',
                      tabs: [
                          {
                              id: 0,
                              name: 'Infrastructure',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalInfrastructureMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalInfrastructureXml',
                                      options: {},
                                      seq: 2
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      id: 'historical2user',
                      name: 'User',
                      tabs: [
                          {
                              id: 0,
                              name: 'User',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalUserMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalUserXml',
                                      options: {},
                                      seq: 2
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      id: 'historical2endpoints',
                      name: 'Endpoints',
                      tabs: [
                          {
                              id: 0,
                              name: 'Managed Endpoints',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalManagedEndpointMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalManagedEndpointXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 1,
                              name: 'Unmanaged Endpoints',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalUnmanagedEndpointMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalUnmanagedEndpointXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 2,
                              name: 'Inventory',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalEndpointInventoryMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalEndpointInventoryXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          },
                          {
                              id: 3,
                              name: 'Call Details',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalEndpointCallMetadataXml',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalEndpointCallXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'rooms',
                      name: 'Rooms',
                      tabs: [
                          {
                              id: 0,
                              name: 'Rooms',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalRoomsMetadata',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalRooms',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'historical2schedules',
                      name: 'Reports',
                      tabs: [
                          {
                              id: 0,
                              name: 'Schedules',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'historical2Schedules',
                                      options: {}, //  { id: 'logialerts1' }
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },{
                      id: 'historical2clustercapacitydetails',
                      name: 'Capacity Details',
                      tabs: [
                          {
                              id: 0,
                              name: 'Details',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalClusterCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalClusterCapacityDetailsParticipantsXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }, {
                      id: 'historical2trunkcapacitydetails',
                      name: 'Trunk Capacity Details',
                      tabs: [
                          {
                              id: 0,
                              name: 'Trunk Capacity Details',
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'HistoricalTrunkCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'HistoricalTrunkCapacityDetailsParticipantsXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }, {
                      id: 'concurrentCallsCapacityDetails',
                      tabs: [
                          {
                              id: 0,
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'ConcurrentCallsCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'ConcurrentCallsCapacityDetailsParticipantsXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'concurrentBandwidthCapacityDetails',
                      tabs: [
                          {
                              id: 0,
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'ConcurrentBandwidthCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'ConcurrentBandwidthCapacityDetailsParticipantsXml',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'sysConcurrentMeetingPeakBySysTypeCapacityDetails',
                      tabs: [
                          {
                              id: 0,
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'SysConcurrentMeetingPeakBySysTypeCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'SysConcurrentMeetingPeakBySysTypeCapacityDetailsTable',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'sysConcurrentMeetingPeakBySysNameCapacityDetails',
                      tabs: [
                          {
                              id: 0,
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'SysConcurrentMeetingPeakBySysNameCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'SysConcurrentMeetingPeakBySysNameCapacityDetailsTable',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  },
                  {
                      id: 'sysTypeConcurrentMeetingPeakCapacityDetails',
                      tabs: [
                          {
                              id: 0,
                              type: 'fixed',
                              fixedpanels: [
                                  {
                                      componentType: 'SysTypeConcurrentMeetingPeakCapacityDetailsTrend',
                                      options: {},
                                      seq: 1
                                  },
                                  {
                                      componentType: 'SysTypeConcurrentMeetingPeakCapacityDetailsTable',
                                      options: {},
                                      seq: 2
                                  }
                              ],
                              panels: []
                          }
                      ]
                  }
              ]
          },
          {
              id: 'devicedetails', name: 'Device Details', views: [
                  {
                      id: 'endpointdetail',
                      name: 'Endpoint Detail',
                      tabs: [
                          {
                              id: 0, name: 'Codec', type: 'fixed', fixedpanels: [{
                                  componentType: 'EndpointCodecInfo',
                                  options: {},
                              }], panels: []
                          },
                          {
                              id: 1, name: 'AV', type: 'fixed', fixedpanels: [{
                                  componentType: 'EndpointAVInfo',
                                  options: {},
                              }], panels: []
                          },
                          {
                              id: 2, name: 'Calls', type: 'fixed', fixedpanels: [{
                                  componentType: 'EndpointInfoActiveCalls',
                                  options: {},
                                  seq: 1
                              }, {
                                  componentType: 'EndpointInfoHistoricalCalls',
                                  options: {},
                                  seq: 2
                              }], panels: []
                          },
                          {
                              id: 3, name: 'Network', type: 'fixed', fixedpanels: [{
                                  componentType: 'EndpointNetworkInfo',
                                  options: {},
                              }], panels: []
                          }
                      ]
                  }
              ]
          },
          {
              id: 'settings', name: 'Settings', views: [
                  {
                       id: 'settings',
                      name: 'settings',
                      tabs: [
                          {
                              id: 0, name: 'Endpoints', type: 'fixed', fixedpanels: [{
                                  componentType: 'EndpointManagementGrid',
                                  options: {},
                              }], panels: []
                          },
                          {
                              id: 1, name: 'Rooms', type: 'fixed', fixedpanels: [{
                                  componentType: 'RoomGrid',
                                  options: { type: 'rooms'}
                              }], panels: []
                          }
                      ]
                  }
              ]
          }
      ]
};

PreferenceManager.prototype = {
    setDataProvider: function(dp) {
        var self = this;
        self.dataProvider = dp;
    },

    invokeGetPreferences: function (prefKey) {
        var self = this;
        if (self.deferredGetPreferences[prefKey]) {
            // there's already a request out for the same preference key, return the cached promise
            return self.deferredGetPreferences[prefKey];
        }

        return self.deferredGetPreferences[prefKey] = DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL().then(function(dashboardUrlBase) {
          return WebResourceSecure.getJSON(dashboardUrlBase + '/userPreferences/' + prefKey).then(function(response) {
            return JSON.parse(response.d);
          }, (error) => console.error('Error fetching preferences', error))
          .finally(function() {
            delete self.deferredGetPreferences[prefKey];
          });
        });
    },

    fetchPreferences: function () {
        var self = this;
        return self.invokeGetPreferences('vAnalyticsUserPreferences');
    },

    // This function checks if a save is possible before calling 'self._savePreferences' to do the real save
    savePreferences: function () {
        var self = this;

        // Disable SavePreferences if nosave=true parameter is on the URL
        if (hasNoSaveURLParam()) {
            return Promise.resolve(self.preferences);
        }

        if (self.preferences !== null && _.isEmpty(self.preferences)) {
            if (self.dataProvider) {
                // try {
                    console.warn('trying to save an empty preferences object');
                    console.trace();
                    Error.stackTraceLimit = 100;
                    self.dataProvider.logActivity2('preferences', 'preferences-manager.js', 'trying to save empty preference object', StackTrace.getSync());
                // } catch (e) {
                //     console.warn('trying to save an empty preferences object, and error trying to log activity');
                // }
            }
            return Promise.reject('trying to save an empty preferences object ' + self.preferences);
        }

        if (self.__savePreferencesLocked) {
            // There's a save in progress
            if (!self.__isSaveQueued) {
                // queue the request
                self.__isSaveQueued = true;
            }
            return Promise.resolve(self.preferences);
        }
        // no save in progress, proceed
        return self._savePreferences();
    },

    _savePreferences: function () {
        var self = this;

        self._lockSavePreferences();

        return self.fetchPreferences().then(function(prefs) {
            var currentLastUpdated = _.get(self.preferences, 'lastUpdated');
            if (currentLastUpdated && moment(currentLastUpdated).isBefore(moment(_.get(prefs, 'lastUpdated')))) {
                StalePreferencesDialog.showModal().then(function(override) {
                    if (!override) {
                        window.location.reload();
                    }
                    else {
                        return self.invokeSavePreferences();
                    }
                });
                return;
            }
            return self.invokeSavePreferences();
        })
        .catch(function() {
            console.error('PreferenceManager:: savePreferences failed!');
        });
    },

    invokeSavePreferences: function() {
        var self = this;
        if (self.preferences !== null && _.isEmpty(self.preferences)) {
            // todo this should no longer be called because it's being prevented in savePreferernces
            if (self.dataProvider) {
                // try {
                    console.warn('trying to save an empty preferences object');
                    console.trace();
                    Error.stackTraceLimit = 100;
                    self.dataProvider.logActivity2('preferences', 'preferences-manager.js', 'trying to save empty preference object', StackTrace.getSync());
                // } catch (e) {
                //     console.warn('trying to save an empty preferences object, and error trying to log activity');
                // }
            }
            return Promise.reject('trying to save an empty preferences object ' + self.preferences);
        }

        return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL().then(function (dashboardUrlBase) {
          return WebResourceSecure.getJSON(dashboardUrlBase + '/userPreferences/vAnalyticsUserPreferences', self.preferences, 'POST')
            .then(function (response) {
                var json = response.d;
                if (json && json.length > 0) {
                  return JSON.parse(json);
                }
                return '';
            })
            .then(function (savedPreferences) {
                self.preferences = savedPreferences;
                self._unlockSavePreferences();
            })
            .catch(function () {
                self._unlockSavePreferences();
            });
        });
    },

    _lockSavePreferences: function() {
        var self = this;
        self.__savePreferencesLocked = true;
    },

    _unlockSavePreferences: function() {
        var self = this;
        self.__savePreferencesLocked = false;
        if (self.__isSaveQueued) {
            self._savePreferences();
            self.__isSaveQueued = false;
        }
    },

    saveGlobalPreferences: function (globalData) {
        var self = this;

        self.preferences = globalData;
        return self.savePreferences();
    },

    clearPreferences: function () {
        var self = this;
        self.preferences = null;
        self.dataProvider.logActivity2('preferences', 'preferences-manager.js', 'clearing preferences');
        return self.savePreferences();
    },

    getGlobalPreferences: function () {
        var self = this;
        var promise = _.isEmpty(self.preferences) ?
            self.invokeGetGlobalPreferences() :
            Promise.resolve(self.preferences);

        return promise;
    },

    invokeGetGlobalPreferences: function () {
        var self = this;

        return self.fetchPreferences().then(function (prefs) {
            if (_.isEmpty(prefs)) {
                // Set default preferences
                var defaultPrefs = GetDefaultPreferences();

                if (self.isAdvancedAnalyticsEnabled()) {
                    return self.getDefaultAdvancedAnalyticsPreferences()
                    .finally(function () {
                        self.preferences = defaultPrefs;
                        self.setDefaultAdvancedAnalyticsPreferences();
                    })
                    .finally(function() {
                        self.savePreferences();
                    });
                }
                else {
                    self.preferences = defaultPrefs;
                    return self.savePreferences();
                }
            }
            else {
                return GetAndSaveAdjustedPreferences(prefs, self);
            }
        }, (error) => console.error('Error fetching preferences', error));
    },

    getDefaultAdvancedAnalyticsPreferences: function () {
        var self = this;

        if (_.isEmpty(self.defaultAAPrefs)) {
            return DashboardService.fetchPreferences('historical2').then(function(result) {
                self.defaultAAPrefs = result;
                return self.defaultAAPrefs;
            }, (error) => console.error('Error fetching preferences', error));
        }
        return Promise.resolve(self.defaultAAPrefs);
    },

    saveAppPreferences: function (appId, appData) {
        var self = this;

        if (_.has(self.preferences, 'apps')) {
            var appIndex = FindIndexById(self.preferences.apps, appId);

            if (appIndex >= 0) {
                self.preferences.apps[appIndex] = appData;
            }
            else {
                self.preferences.apps.push(appData);
            }
        }
        else {
            self.preferences.apps = [ appData ];
        }
        return self.savePreferences();
    },

    getAppPreferences: function (appId) {
        var self = this;

        return self.getGlobalPreferences().then(function () {
            // get app or default
            var app = FindById(_.get(self.preferences, 'apps'), appId);
            if (_.isEmpty(app)) {
                app = FindById(GetDefaultPreferences().apps, appId);
                self.preferences.apps.push(app); // insert the default preferences
            }

            if (_.isEmpty(app)) {
                throw new Error('PreferenceManager::getAppPreferences(): app "' + appId + '" was not found in preferences nor default values.');
            }

            return app;
        });
    },

    getListOfFlexViews: function (appId) {
        var self = this;

        return self.getAppPreferences(appId).then(function (app) {
            var views = [];

            if (app && app.views) {
                app.views.forEach(function (view) {
                    var newView = { id: view.id, name: view.name, tabs: [] };

                    view.tabs.forEach(function (tab) {
                        if (tab.type === 'flex') {
                            newView.tabs.push({ id: tab.id, name: tab.name, viewId: view.id, appId: appId });
                        }
                    });

                    if (newView.tabs.length > 0) {
                        views.push(newView);
                    }

                });
            }

            return views;
        });
    },

    saveViewPreferences: function (appId, viewId, viewData) {
        var self = this;

        return self.getAppPreferences(appId).then(function (app) {
            if (_.has(app, 'views')) {
                var viewIndex = FindIndexById(app.views, viewId);

                if (viewIndex >= 0) {
                    app.views[viewIndex] = viewData;
                }
                else {
                    app.views.push(viewData);
                }
            }
            else {
                app.views = [ viewData ];
            }
            return self.savePreferences();
        });
    },

    saveViewLevelProperties2: function (appId, viewIdsAndPrefs) {
        var self = this;

        return self.getAppPreferences(appId, true).then(function (app) {
            if (app) {
                for (var i = 0; i < viewIdsAndPrefs.length; i++) {
                    var viewId = viewIdsAndPrefs[i].viewId;
                    var viewPrefs = viewIdsAndPrefs[i].viewPrefs;
                    var view = FindById(app.views, viewId);

                    $.extend(view, viewPrefs);
                }
                return self.savePreferences();
            }
            else {
                return Promise.resolve();
            }
        });
    },

    deleteTab: function (appId, viewId, tabId) {
        var self = this;
        return self.getViewPreferences(appId, viewId)
            .then(function(viewprefs) {

                var index = -1;
                for (var i = 0; i < viewprefs.tabs.length; i++) {

                    if (viewprefs.tabs[i].id == tabId) { // the id in the prefs might be a int vs string
                        index = i;
                        break;
                    }
                }

                if (index !== -1 && tabId != 0) { // don't delete if match not found or match is default
                    viewprefs.tabs.splice(index, 1);

                    return self.saveViewPreferences(appId, viewId, viewprefs);
                } else {
                    return Promise.reject();
                }
            });
    },

    getViewPreferences: function (appId, viewId) {
        // UI-2887 we used to fetch preferences but this should only be used for settings and reports and not ned to store preferences
        return this.getAppPreferences(appId).then(function (app) {
            let defaultApp = FindById(GetDefaultPreferences().apps, appId); //local preferences; used for RT
            let view = FindById(defaultApp.views, viewId);
            if(_.isEmpty(view)) //we need to get prefs from the server
            {
                self.getDefaultAdvancedAnalyticsPreferences().then(function (defaultAAprefs) {
                    view = FindById(defaultAAprefs.views, viewId);
                    if (_.isEmpty(view)) {
                        var appStringified = JSON.stringify(app);
                        throw new Error('PreferenceManager::getViewPreferences(): Could not find preferences or default values for app: ' + appStringified + ', view: ' + viewId + ' in local or AA defaults');
                    }
                });
            }
            if (_.isArray(app.views)) {
                 if(!FindById(app.views, viewId)) {
                     app.views.push(view); // add the default view settings
                 }
            } else {
                 app.views = [ view ]; // set the default view settings
            }
            return view;
        });
    },

    getListOfTabs: function (appId, viewId) {
        var self = this;

        return self.getViewPreferences(appId, viewId).then(function (view) {
            var tabs = [];

            if (view && view.tabs) {

                view.tabs.forEach(function (tab) {

                    tabs.push({ id: tab.id, name: tab.name });

                });
            }

            return tabs;
        });
    },

    saveAdvancedAnalyticsDateRange: function(dateRange) {
        var self = this;
        var formattedDateRange = _.mapValues(dateRange, function(momentDate) {
            return momentDate.format('YYYY-MM-DD');
        });

        return self.getAppPreferences('historical2').then(function(app) {
            _.forEach(app.views, function(view) {
                _.forEach(view.tabs, function(tab) {
                    if (tab) {
                        tab.selectedDateRangeValues = formattedDateRange;
                    }
                });
            });
            return self.savePreferences();
        });
    },

    saveTabPreferences: function (appId, viewId, tabId, tabData) {
        var self = this;

        return self.getViewPreferences(appId, viewId).then(function(view) {
            if (_.has(view, 'tabs')) {
                var tabIndex = FindIndexById(view.tabs, tabId);

                if (tabIndex >= 0) {
                    view.tabs[tabIndex] = tabData;
                }
                else {
                    view.tabs.push(tabData);
                }
            }
            else {
                view.tabs = [ tabData ];
            }

            return self.savePreferences();
        });
    },


    getTabPreferences: function (appId, viewId, tabId) {
        var self = this;

        return self.getViewPreferences(appId, viewId).then(function (view) {
            var tab = null;

            if (view) {
                tab = FindById(view.tabs, tabId);
            }

            return tab;
        });
    },

    setAvailableModules: function (modules) {
        var self = this;
        self.modules = modules;
    },

    isAdvancedAnalyticsEnabled: function () {
        var self = this;
        return !!self.modules.AdvancedAnalytics;
    },

    setDefaultAdvancedAnalyticsPreferences: function () {
        var self = this;
        if (_.isEmpty(self.defaultAAPrefs) || !_.has(self.preferences, 'apps')) {
            return;
        }
        var advAnalyticsApp = _.find(self.preferences.apps, { id: 'historical2' });
        if (_.isEmpty(advAnalyticsApp)) {
            // no preferencs found for Advanced Analytics, set it from default
            return self.preferences.push(self.defaultAAPrefs);
        }
        _.forEach(self.defaultAAPrefs.views, function (defaultView) {
            var viewIndex = _.findIndex(advAnalyticsApp.views, { id: defaultView.id });
            if (viewIndex < 0) {
                // no view found, add it
                advAnalyticsApp.views.push(defaultView);
            }
            else {
                // replace existing with default
                advAnalyticsApp.views[viewIndex] = defaultView;
            }
        });
    },

    getDefaultPreferences: function() {
        return GetDefaultPreferences();
    },

    dispose: function () {
        var self = this;
        self.preferences = {};
        self.deferredGetPreferences = {}; // holds pending get preferences calls to enable filtering of duplicate requests
    }
};

function GetDefaultPreferences() {
    return JSON.parse(JSON.stringify(DEFAULT_PREFERENCES));
}

function hasNoSaveURLParam() {
    return /[?&]nosave=true/.test(window.location.href);
}

function GetHistorical2ViewsFromDefault() {
    var defPrefs = GetDefaultPreferences();

    var app = FindById(defPrefs.apps, "historical2");

    return app.views;
}

function GetHistoricalViewsFromDefault() {
    var defPrefs = GetDefaultPreferences();

    var app = FindById(defPrefs.apps, "historical");

    return app.views;
}

function GetWebexViewsFromDefault() {
    var defPrefs = GetDefaultPreferences();

    var app = FindById(defPrefs.apps, "webex");

    return app.views;
}

// This function seeks to ensure that the user's preferences structure is up to date with the latest changes to the structure.
// Whenever we make a change to the structure (explained later), we should update the version number so we can compare
// the user's version with our latest structure version.
// By structure, we mean apps, views and tabs, and those properties of apps, views and tabs that are not user dependent.
// Changes to dashboards and panel options does not constitute a version change as it doesn't change the structure.
// Latest version is always in getdefaultpreferences()

function GetAndSaveAdjustedPreferences(prefs, self) {
    var defaultPreferences = GetDefaultPreferences();

    self.preferences = prefs;

    // clean up duplicates
    prefs.apps = pruneDuplicateIds(prefs.apps);
    _.forEach(prefs.apps, function(app) {
        app.views = pruneDuplicateIds(app.views);
    });

    // if user's preference version is the same as our latest version no need to do anything
    if (prefs && (prefs.version === defaultPreferences.version)) {
        return Promise.resolve(prefs);
    }

    var change = false;

    var adminApp = FindById(prefs.apps, "admin");
    var defaultSettingsApp = FindById(defaultPreferences.apps, "settings");

    if (adminApp) {
        RemoveById(prefs.apps, "admin");
        RemoveById(prefs.apps, "settings");
    }

    var settingsApp = FindById(prefs.apps, "settings");
    if (!settingsApp) {
        prefs.apps.push(defaultSettingsApp);
        change = true;
    } else {
        if (prefs.version < 12017073100) {
            if (settingsApp.views[0].tabs.length < 3) {
                settingsApp.views[0].tabs.push(defaultSettingsApp.views[0].tabs[2]);
                prefs.version = defaultPreferences.version;
                change = true;
            }
        }
    }

    var devicedetailsapp = FindById(prefs.apps, "devicedetails");

    var dapp = FindById(defaultPreferences.apps, "devicedetails");

    if (!devicedetailsapp) {

        prefs.apps.push(dapp);

        change = true;
    } else {

        if (devicedetailsapp.views[0].tabs[2].fixedpanels.length === 1) {
            devicedetailsapp.views[0].tabs[2].fixedpanels = dapp.views[0].tabs[2].fixedpanels;
            change = true;
        }
    }


    var lyncapp = FindById(prefs.apps, "lync");

    if (!lyncapp) {
        var lapp = FindById(defaultPreferences.apps, "lync");

        prefs.apps.push(lapp);

        change = true;
    }

    var historical2app = FindById(prefs.apps, "historical2");

    var h2app = FindById(defaultPreferences.apps, "historical2");

    if (!historical2app) {

        prefs.apps.push(h2app);

        prefs.version = defaultPreferences.version;

        change = true;
    }
    else {

        if (prefs.version < 12017013001) {

            if (RemoveById(prefs.apps, "historical2")) {

                prefs.apps.push(h2app);

                prefs.version = defaultPreferences.version;

                change = true;
            }

        }
        if (prefs.version < 12017050801) {

            var hist2views = GetHistorical2ViewsFromDefault();

            var clusterview = FindById(hist2views, 'historical2clustercapacitydetails');

            var hist2apps = FindById(prefs.apps, "historical2");
            if (!FindById(hist2apps.views, 'historical2clustercapacitydetails')) {
                hist2apps.views.push(clusterview);

                prefs.version = defaultPreferences.version;

                change = true;
            }
        }
    }

    for (var i = 0; i < prefs.apps.length; i++) {

        var app = prefs.apps[i];

        if ((app.id === "historical") && ((!app.views) || (app.views.length < 6))) {

            app.views = GetHistoricalViewsFromDefault();

            change = true;
        }

        if (!app.views) {

            continue;
        }

        //webex change from logi to tables
        if (app.id === "webex") {

            var webexviews = GetWebexViewsFromDefault();

            var wlmview = FindById(webexviews, "webexmeetings");
            var wluview = FindById(webexviews, "webexusers");
            var wlpview = FindById(webexviews, "webexparticipants");

            if (RemoveById(app.views, "webexlogimeetings")) {
                app.views.push(wlmview);
                change = true;
            }

            if (RemoveById(app.views, "webexlogiusers")) {
                app.views.push(wluview);
                change = true;
            }

            if (RemoveById(app.views, "webexlogiparticipants")) {
                app.views.push(wlpview);
                change = true;
            }

            if (RemoveNulls(app.views)) {
                change = true;
            }

            if (!FindById(app.views, "webexschedules")) {
                var wrsview = FindById(webexviews, "webexschedules");
                app.views.push(wrsview);
                change = true;
            }

        }


        if (app.id === "historical") {


            //historicallogimeetings, historicallogiendpoints

            var histviews = GetHistoricalViewsFromDefault();

            var hmview = FindById(histviews, "historicalmeetings");
            var heview = FindById(histviews, "historicalendpoints");

            if (RemoveById(app.views, "historicallogimeetings")) {
                app.views.push(hmview);
                change = true;
            }

            if (RemoveById(app.views, "historicallogiendpoints")) {
                app.views.push(heview);
                change = true;
            }

            var hliview = FindById(app.views, "historicallogiissues");

            if (RemoveById(hliview.tabs, 1)) {
                change = true;
            }

            if (!FindById(app.views, "historicalschedules")) {
                var hrsview = FindById(histviews, "historicalschedules");
                app.views.push(hrsview);
                change = true;
            }

            var heview2 = FindById(app.views, "historicalendpoints");

            if (heview2.tabs.length < 4) {
                heview2.tabs.push(heview.tabs[3]);
                change = true;
            }

            if (RemoveById(heview2.tabs, 7)) {
                change = true;
            }
            if (RemoveById(heview2.tabs, 6)) {
                change = true;
            }
            if (RemoveById(heview2.tabs, 5)) {
                change = true;
            }
            if (RemoveById(heview2.tabs, 4)) {
                change = true;
            }

            var hmview2 = FindById(app.views, "historicalmeetings");

            if (RemoveById(hmview2.tabs, 5)) {
                change = true;
            }
            if (RemoveById(hmview2.tabs, 4)) {
                change = true;
            }
            if (RemoveById(hmview2.tabs, 3)) {
                change = true;
            }

            if (RemoveById(app.views, "historicaldashboard")) {
                change = true;
            }

            if (RemoveById(app.views, "historicaladoption")) {
                change = true;
            }

            if (RemoveById(app.views, "historicalissues")) {
                change = true;
            }

            if (RemoveById(app.views, "historicalcapacity")) {
                change = true;
            }

            if (RemoveById(app.views, "historicalcapacitydetails")) {
                change = true;
            }

        }

        if (RemoveNulls(app.views)) {
            change = true;
        }

        //setting tab types to fixed and flex
        for (var j = 0; j < app.views.length; j++) {

            var view = app.views[j];
            if (RemoveNulls(view.tabs)) {
                change = true;
            }

            for (var k = 0; k < view.tabs.length; k++) {

                var tab = view.tabs[k];

                if (!tab.type) {

                    tab.type = 'fixed';

                    if ((view.id === 'rtdashboard') || (view.id === 'rtcapacity') || ((view.id === 'rtendpoints') && (tab.id !== 1))) {
                        tab.type = 'flex';
                    }

                    change = true;
                }
            }
        }
    }

    if (change) {
        //make sure to update version number to latest to avoid future re-evaluations
        prefs.version = defaultPreferences.version;
        self.preferences = prefs;
        return self.savePreferences();
    } else {
        return Promise.resolve(prefs);
    }
}

PreferenceManager.getInstance = function() {
    if (instance === null) {
        instance = new PreferenceManager();
    }
    return instance;
};

export default PreferenceManager.getInstance();
